import { AddMouseDownListener, AddMouseDownUpListener, AddMouseUpListener, CreateElement, Log, Scale, SetStyles } from "../.././MyHelpers";
import { AudioManager, Track } from "../../AudioManager";
import { IInterval } from "../../Context/Interval";
import { ISystemContext } from "../../Context/SystemContext";
import { ITimeout } from "../../Context/Timeout";
import { Button } from "../../IO";
import { MoneyFormatter } from "../../MoneyFormatter";
import { ImageResource } from "../../ResourceManager/ImageResource";
import { Resourceful } from "../../ResourceManager/Resourceful";
import { ResourceIdentifier } from "../../ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, ResourceManager } from "../../ResourceManager/ResourceManager";
import { MenuType, Settings } from "../../Settings";
import { TranslatedLocation, Translator } from "../../Translator";
import { ZIndex } from "../../ZIndex";
import { GameState } from "../GameState";
import { PanelParams } from "./IPanelFactory";
//import { service } from "../../services";
import { IBackendSettingsService } from "../../../services/BackendSettingsService";
import { BetConfig, Money, SlotGameBet } from "../../api";
import { service } from "../../services";
import { SettingsIconMap } from "./IPopUpPanelIcons";
import { ChangeSpeedParams, SlotGameType1 } from "../SlotGameType1";
import { Orientation } from "../../FitScreen";
import { FreeRoundsStats } from "../../../singlegame/singlegame_api";

// export enum PanelButton
// {
// 	Spin,
// 	Lines,
// 	BetPerLine,
// 	Denom,
// 	AutoPlay,
// 	MaxBet,
// 	Help,
// 	Collect,
// 	GamesMenu,
// 	Volume,
// 	Credit,
// 	Denom2,
//     Bet1,
//     Bet2,
//     Bet3,
//     Bet4,
//     Bet5,
//     Bet6,
//     Bet7,
//     Bet8,
//     Bet9,
//     Bet10,
    
//     BetDown,
//     BetUp,
// }

//Panel
export interface ButtonColors
{
	backgroundButtonColor:string;
	linearColor:string;
}


export type PanelButtonPressedCallback = (button: Button, pressed: boolean) => void;

// class PanelButtonAnim
// {
// 	public transparency: number = 0;
// 	public color:number = 0;
// 	public animation: any = null;
// }

export interface ButtonState
{
    button: Button;
    isPressed: boolean;
    element: HTMLElement;

    delayReleaseTime: ITimeout;
    releasePending: boolean;

    autoReleaseTimer: ITimeout;

    // public constructor(button: PanelButton, elem: HTMLElement)
    // {
    //     this.button = button;
    //     this.element = elem;


    // }

    
}

export class Panel implements Resourceful
{
    
    protected SELECTOR = `input[type="range"]::-webkit-slider-thumb {
        -webkit-appearance: none;
        appearance: none;
        width: ${Scale.Wpx(80)};
        height: ${Scale.Hpx(120)};
        background-image: linear-gradient(to bottom, #b0b0b0 0%, #ffffff 50%, #a8a8a8 100%);
        cursor: pointer;
        border-radius: ${Scale.XYpx(16)};
        border: ${Scale.XYpx(7)} solid transparent;
        border-style: "inset";
        margin: ${Scale.Wpx(5)} ${Scale.Hpx(10)};
        display: "flex";
        background-origin: "border-box";
        background-clip: "content-box; border-box";
        border: solid;
        border-color: darkgoldenrod;
    }`;

	protected view: HTMLElement = null;

	
	protected butElem: Map<Button, HTMLElement> = new Map<Button, HTMLElement>();
	//protected butPressedAnim: Map<PanelButton, PanelButtonAnim> = new Map<PanelButton, PanelButtonAnim>();

	protected resourcesBasePath: string = "";
	protected resid: ResourceIdentifier = null;

    protected popUpContainer: HTMLElement = null;
    protected popUpMenu: HTMLElement = null;
    protected volumeRange: HTMLInputElement = null;
    protected volumeSelectorStyle: HTMLElement = null;
    protected SpeedSelectortStyle: HTMLElement = null;
    protected SpeedRange: HTMLInputElement;
    protected butSpeed: HTMLDivElement
	//private resprefix: string = "panel";

	protected autoplayAnimation : any = null; // gsap animation

	protected volume:number = 0;
	protected audio: AudioManager = null;
    protected game: SlotGameType1;


	protected volume0:ImageResource= null;
	protected volume1:ImageResource= null;
	protected volume2:ImageResource= null;
	protected volume3:ImageResource= null;

	protected play:ImageResource= null;
	protected menu:ImageResource= null;


	protected idleAnim: IInterval;
	protected idleAnimState: boolean = false;

	protected resourcePath:string  = Settings.ResourcesFolder + "multigame/panel/";

    protected betTypeLabel: HTMLElement;
    protected betValue: HTMLElement;

	protected balanceCredits: HTMLElement;
	protected balanceCurrency: HTMLElement;

    protected freeRoundsRemaining: HTMLElement;
    protected freeRoundsRemainingText: TranslatedLocation;
    

	protected winCredits: HTMLElement;
	protected winCurrency: HTMLElement;

	// protected balanceCredits: HTMLElement;
	// protected balanceCurrency: HTMLElement;

    protected totalBet: Money = null;
	protected betCredits: HTMLElement;
	protected betCurrency: HTMLElement;

	protected totalBetCredits: HTMLElement;
	protected totalBetCurrency: HTMLElement;


	protected denomElem: HTMLElement;
	protected linesElem: HTMLElement;
	protected spinElem: HTMLElement;

    protected turboElem: HTMLElement;
    protected messageElem: HTMLElement;
    protected attendantElem: HTMLElement;
	//protected turboAnimState: boolean = false;
	//protected turboAnim: IInterval;

	protected systemContext: ISystemContext;
    protected translator: Translator;
    
    
	//elements
	//private bet
    protected backendSettings: IBackendSettingsService;
    
    protected buttonState: Map<Button, ButtonState> = new Map<Button, ButtonState>();

    //protected defaulbets = ["50","100","150","200","250","300"];
    protected panelColors:ButtonColors = null;

    protected params: PanelParams;
    protected butVolLabel: HTMLElement = null;


	public constructor(params: PanelParams)
	{
        this.params = params;

		this.backendSettings = params.backendSettings;
		this.resid = params.resid.Add("Panel");
		this.resourcesBasePath = params.resourcesBasePath;
        this.audio = params.audio;
		this.translator = params.translator;

		this.systemContext = params.systemContext.CreateSubContext("Panel");

		this.idleAnim = this.systemContext.TimingContext().CreateInterval("idleAnim", 500, () => this.IdleAnim())
        this.panelColors = params.panelColor;
        if (Settings.EnablePanelWithSettings)
            {
                this.butVolLabel = CreateElement("div", {
                    classes: ["but-vol-value", "label"],
                    parentToAppend: this.butVolume,
                    style: {
                        ...this.cssLabel
                    }
                });
            }
        
	}

    protected switched: boolean = false;
    public ToggleCreditMoney() {
        this.switched = !this.switched;

        if (this.switched) {
            this.balanceCredits.textContent = this.balanceCurrencyValue;
            this.balanceCurrency.textContent = this.balanceCreditValue;

            this.winCredits.textContent = this.winCurrencyValue;
            this.winCurrency.textContent = this.winCreditsValue;

            this.totalBetCredits.textContent = this.totalBetCurrencyValue;
            this.totalBetCurrency.textContent = this.totalBetCreditsValue;
        }
        else {
            this.balanceCredits.textContent = this.balanceCreditValue;
            this.balanceCurrency.textContent = this.balanceCurrencyValue;

            this.winCredits.textContent = this.winCreditsValue;
            this.winCurrency.textContent = this.winCurrencyValue;

            this.totalBetCredits.textContent = this.totalBetCreditsValue;
            this.totalBetCurrency.textContent = this.totalBetCurrencyValue;
        }
    }

    protected freeRoundsStats: FreeRoundsStats;

    public SetFreeRoundsStats(freeRoundStats: FreeRoundsStats){
        this.freeRoundsStats = freeRoundStats;

        this.UpdateFreeRoundsStats();
    }

    public UpdateFreeRoundsStats()
    {
        if (!this.freeRoundsRemaining)
        {
            return;
        }


        if (!this.freeRoundsStats ||
            this.freeRoundsStats.PlayedFreeRoundsNumber == this.freeRoundsStats.FreeRoundsNumber ||
            this.freeRoundsStats.FreeRoundsBet.InCents !== this.totalBet.InCents
        )
        {
            this.freeRoundsRemaining.style.display = "none";
            return;
        }

        this.freeRoundsRemaining.style.display = "";
        this.freeRoundsRemainingText?.Update();
    }

    protected ConstructHtmlWithSettingsBtn()
    {
        this.popUpContainer = CreateElement("div", {
             classes:["pop-up", "container"],
             parentToAppend: this.view,
             style:
             {
                 display: "none",
                 position: "absolute",
                 bottom: Scale.Ypx(165),
                 width: Scale.Wpx(1920),
                 height: Scale.Hpx(1080),
                 justifyContent: "center",
                 alignItems: "flex-end",
                 //zIndex: ZIndex.SettingsMenu.toString(),
             },
             
            })
          //  this.popUpContainer.addEventListener('mousedown', () => {if (this.allowToHidePopUpItems) this.HidePopUp()})
     
             let cssLinear: Partial<CSSStyleDeclaration> = {
                 borderWidth: Scale.XYpx(5),
                 borderStyle: "solid",
                 position: "relative",
                 margin: "0px auto",
                 bottom: Scale.Ypx(5),
                 filter: `blur(${Scale.XYpx(2)})`,
                 width: "80%",
                 borderImage: this.ButtonBackground().linearColor
     
             };
     
     
             let cssVerticalGroup: Partial<CSSStyleDeclaration> = {
                 display: "flex",
                 flexDirection: "column",
                 //justifyContent: "flex-end",
             };
     
             let cssHorizontalGroup: Partial<CSSStyleDeclaration> = {
                 display: "flex",
                 flexDirection: "row",
                 flexGrow: "1",
                 alignItems: "end",
             };
     
             let cssLeftRightButton: Partial<CSSStyleDeclaration> = {
                 flexGrow: "1",
                 height: Scale.Hpx(47),
                 width: Scale.Wpx(85),
             };
     
             let cssButton: Partial<CSSStyleDeclaration> = {
                 borderRadius: Scale.XYpx(16),
     
                 border: `${Scale.XYpx(7)} solid transparent`,
                 //backgroundClip: "padding-box",
                 borderStyle: "inset",
     
                 margin: `${Scale.Wpx(5)} ${Scale.Hpx(10)}`,
                 height: Scale.Hpx(100),
     
                 display: "flex",
                 flexDirection: "column",
                 justifyContent: "space-evenly",
     
                 backgroundOrigin: "border-box",
                 backgroundClip: "content-box, border-box",
                 backgroundImage: this.ButtonBackground().backgroundButtonColor
             };
             
             let color1: ButtonColors = {
                backgroundButtonColor: "linear-gradient(rgb(139, 0, 0), rgb(178, 34, 34), rgb(139, 0, 0)), linear-gradient(#BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
                linearColor: "linear-gradient(to left, transparent, LightGoldenrodYellow, transparent) 0 10 100%",
            };
            
            let cssButton1: Partial<CSSStyleDeclaration> = {
                borderRadius: Scale.XYpx(16),
        
                border: `${Scale.XYpx(7)} solid transparent`,
                //backgroundClip: "padding-box",
                borderStyle: "inset",
            
                margin: `${Scale.Wpx(5)} ${Scale.Hpx(10)}`,
                height: Scale.Hpx(100),
            
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-evenly",
            
                backgroundOrigin: "border-box",
                backgroundClip: "content-box, border-box",
                backgroundImage: color1.backgroundButtonColor,
            };

             let cssLabel: Partial<CSSStyleDeclaration> = {
                 fontSize: Scale.fhpx(20),
                 lineHeight: "0px",
                 //color: "white",
                 textAlign: "center",
     
     
                 fontFamily: "NotoSansDisplay-Bold",
                 fontWeight: "bold",
     
                 color: "white",
                 textShadow: Array(Math.round(Scale.XY(18))).fill("#001 0px 0px 4px").join(", ") //.repeat() #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px",
             };
     
             let SvgIcon: Partial<CSSStyleDeclaration> =
             {
                 display: "flex",
                 width: "100%",
                 height: "100%",
                 alignItems: "center",
                 justifyContent: "center"
             }
     
             let horizontalMiniMenu: Partial<CSSStyleDeclaration> =
             {
                 display: "flex",
                 flexDirection: "row",
                 //width:"100%",
                 //height:"100%",
                 alignItems: "center",
                 justifyContent: "center"
             }
     
             let cssMessageValue: Partial<CSSStyleDeclaration> = {
                 display: "flex",
                 justifyContent: "center",
                 alignItems: "center",
                 fontSize: Scale.fhpx(20),
     
                 color: "white",
                 textShadow: "0 0 10px black",
                 background: "transparent",
                 position: "relative",
                 top: "0px",
     
             };
     
             let cssCredit: Partial<CSSStyleDeclaration> = {
                 fontSize: Scale.fhpx(35),
                 lineHeight: Scale.Hpx(40),
                 textAlign: "center",
                 height: "100%",
     
                 display: "flex",
                 justifyContent: "center",
                 alignItems: "center",
     
                 color: "white",
     
                 textShadow: `0 0 ${Scale.XYpx(10)} black`,
                 position: "relative",
                 top: Scale.Ypx(6),
             };
     
             let cssCurrency: Partial<CSSStyleDeclaration> = {
                 fontSize: Scale.fhpx(25),
                 textAlign: "center",
                 color: "yellow",
                 textShadow: `0 0 ${Scale.XYpx(10)} black`,
                 position: "relative",
                 top: Scale.Ypx(12),
                 left: Scale.Ypx(0),
                 margin: Scale.Ypx(0),
             };
     
             this.popUpMenu = CreateElement("div", {
                 classes: ["popup-menu", "items"],
                 parentToAppend: this.popUpContainer,
                 // childToAppend: this.translator.Anchor(() => this.translator.t.optionsbtntxt),
                 style: {
                     //position: "absolute",
                     //display: "none",
                     // bottom: Scale.Ypx(165),
                     backgroundImage: this.ButtonBackground().backgroundButtonColor,
                     justifyContent: "center",
                     width: Scale.Wpx(900),
                     height: Scale.Hpx(900),
                     borderRadius: Scale.XYpx(16),
     
                     border: `${Scale.XYpx(7)} solid transparent`,
                     //backgroundClip: "padding-box",
                     borderStyle: "inset",
         
                     margin: `${Scale.Wpx(5)} ${Scale.Hpx(10)}`,
                     // height: Scale.Hpx(216),
         
                     backgroundOrigin: "border-box",
                     backgroundClip: "content-box, border-box",   
                     //left: Scale.Xpx(15),
                     //zIndex: ZIndex.SettingsMenu.toString()
                 }
             })
             //this.popUpMenu.addEventListener('mouseenter', () => this.allowToHidePopUpItems = false);
             //this.popUpMenu.addEventListener('mouseleave', () => this.allowToHidePopUpItems = true);
     
             /* #region Left column */
             let leftCol = CreateElement("div", {
                 classes: ["but-vertical-group", "but-group-value-collect"],
                 parentToAppend: this.popUpMenu,
                 style: {
                     ...cssVerticalGroup,
                     alignItems: "center",
                    // margin:`${Scale.Wpx(15)} ${Scale.Wpx(15)}`,
                     justifyContent:"space-around"
                 }
             });
     
             let volumeMenu = CreateElement("div", {
                 classes: ["volume-submenu"],
                 parentToAppend: leftCol,
                 style: {
                     ...horizontalMiniMenu,
                     justifyContent: "flex-end"
     
                    // rowGap: Scale.Wpx(15),
                 }
             })
     
             this.butVolume = CreateElement("div", {
                 classes: ["but-vol", "button"],
                 parentToAppend: volumeMenu,
                 style: {
                     // ...cssButton,
                     // ...cssLeftRightButton,
                     width: Scale.Wpx(200),
                     height: Scale.Hpx(200),
                 }
             });
     
             // this.butVolIcon = CreateElement("div", {
             //     classes: ["but-vol-icon", "icon"],
             //     //innerHTML: PopUpPanelIcons.Volume3,
             //     parentToAppend: this.butVolume,
             //     style: {
             //         // ...cssLabel
             //         ...SvgIcon,
             //     }
             // });
     
             this.volumeRange = CreateElement("input", {
                 parentToAppend:volumeMenu,   
                 style: {
                     appearance: "none",
                     width: Scale.Wpx(600),
                     height: Scale.Hpx(50),
                     border: "solid darkgoldenrod",
                     backgroundColor: "transparent",
                     zIndex: "2"
                 }         
             });
     
             this.volumeRange.type = "range";
             this.volumeRange.min = "0";
             this.volumeRange.max = AudioManager.MaxVolumeLevel.toString();
     
     
             this.volumeRange.addEventListener("input", ()=>{
                 this.audio.SetVolume(this.volumeRange.valueAsNumber);
             });
     
             this.volumeSelectorStyle = CreateElement("style",
             {
                 innerHTML:  this.SELECTOR,
                 parentToAppend: this.volumeRange
     
             })
     
             let volumeBackground = CreateElement("div", {
                 classes:["volume-scale", "indicator"],
                 parentToAppend: volumeMenu,
                 style:{
                     width: Scale.Wpx(600),
                     height: Scale.Hpx(50),
                     position: "absolute",
                     //zIndex: "-1",
                     display: "flex",
                     flexDirection: "column"
                     // backgroundColor: "transparente"
                 }
             })
     
             let transparentRectangle = CreateElement("div", {
                 parentToPrepend: volumeBackground,
                 style:
                 {
                     width:"100%",
                     height: "100%",
                     clipPath: "polygon(0% 0%, 100% 0%, 0% 100%)",
                     position: "absolute",
                     top: "0",
                     left: "0",
                     // backgroundColor: "orange"
                 }
             })
     
             let gradientRectangle = CreateElement("div", {
                 parentToAppend: volumeBackground,
                 style:
                 {
                     width:"100%",
                     height: "100%",
                     clipPath: "polygon(0% 0%, 100% 0%, 0% 100%)",
                     position: "absolute",
                     top: "0",
                     right: "0",
                     backgroundImage: "linear-gradient(-90deg, #1e8a00 0%, #ffdd00 50%, #a40e0e 100%)",
                     transform: "rotate(180deg)"
     
                 }
             })
     
             let volumeTitle = CreateElement("div", {
                 classes:["volume","title"],
                 parentToAppend: leftCol,
                 childToAppend: this.translator.Anchor(() => this.translator.t.volumeControlHeader),
                 style: {
                     ...cssLabel,
                     display:"flex",
                     // position: "absolute",
                     width: "100%",
                     height: Scale.Hpx(135),
                     // alignItems: "center",
                     justifyContent: "center",
                 }
             });
             
     
     
     
     
             let speedMenu = CreateElement("div", {
                 classes: ["speed-submenu"],
                 parentToAppend: leftCol,
                 style:{
                     ...horizontalMiniMenu,
                     // rowGap: Scale.Wpx(15),
                 }
             })
             this.butSpeed = CreateElement("div", {
                 classes: ["but-speed", "button"],
                 parentToAppend: speedMenu,
                 style: {
                     // ...cssButton,
                     // ...cssLeftRightButton,
                     width: Scale.Wpx(200),
                     height: Scale.Hpx(200),
                 }
             });
     
             // this.SpeedIcon = CreateElement("div", {
             //     classes: ["but-speed-icon", "icon"],
             //     innerHTML: PopUpPanelIcons.Speed0,
             //     parentToAppend: butSpeed,
             //     style: {
             //         // ...cssLabel
             //         ...SvgIcon
             //     }
             // });
             
             this.SpeedRange = CreateElement("input", {
                 parentToAppend:speedMenu,      
                 style:
                 {
                     appearance: "none",
                     width: Scale.Wpx(600),
                     height: Scale.Hpx(50),
                     backgroundImage: "linear-gradient(to right, #1e8a00 0%, #ffdd00 50%, #a40e0e 100%)",
                     border: "solid darkgoldenrod",
                 }      
             });
     
             this.SpeedRange.type = "range";
             this.SpeedRange.min = "1";
             this.SpeedRange.max = "3";
     
            //  this.SpeedRange.addEventListener("input", ()=>{
            //      this.SetSpeed(this.SpeedRange.valueAsNumber)
                 
            //  });
     
             this.SpeedSelectortStyle = CreateElement("style",
             {
                 innerHTML:  this.SELECTOR,
                 parentToAppend: this.SpeedRange
     
             })
              let speedTitle = CreateElement("div", {
                 classes: ["speed","title"],
                 parentToAppend: leftCol,
                 childToAppend: this.translator.Anchor(() => this.translator.t.speedControlHeader),
     
                 style:{
                     ...cssLabel,
                     // position: "absolute",
                     width: "100%",
                     height: Scale.Hpx(135),
                     display: "flex",
                     // alignItems: "end",
                     justifyContent: "center",
     
                 }
              })
     
     
             let miniMenu = CreateElement("div", {
                 parentToAppend: leftCol,
                 style: {
                     ...horizontalMiniMenu,
                     // rowGap: Scale.Wpx(15)
     
                 }
             })
     
             this.butDenom = CreateElement("div", {
                 classes: ["but-denom", "button"],
                 parentToAppend: miniMenu,
                 style: {
                     ...cssButton,
                     width: Scale.Wpx(120*2),
                     height: Scale.Hpx(100*2),
                 }
             });
     
             this.denomElem = CreateElement("div", {
                 classes: ["denom-value", "message-value"],
                 parentToAppend: this.butDenom,
                 style: {
                     ...cssMessageValue,
                     fontSize: Scale.Wpx(75)
                 }
             });
     
             let butDenomDenom = CreateElement("div", {
                 classes: ["denom-denom"],
                 parentToAppend: this.denomElem
             });
     
             /* #region Left column */
             // let leftCol2 = CreateElement("div", {
             //     classes: ["but-vertical-group", "but-group-payout-attendant"],
             //     parentToAppend: this.popUpMenu,
             //     style: {
             //         ...cssVerticalGroup
             //     }
             // });
     
             this.butHelp = CreateElement("div", {
                 classes: ["but-help", "button"],
                 parentToAppend: miniMenu,
                 style: {
                     ...cssButton,
                     width: Scale.Wpx(120*2),
                     height: Scale.Hpx(100*2),
     
                 }
             });
     
             let butHelpBack = CreateElement("div", {
                 classes: ["help-background"],
                 parentToAppend: this.butHelp
             });
     
             let butHelpLabel = CreateElement("div", {
                 classes: ["but-help-icon", "label"],
                 parentToAppend: butHelpBack,
                 innerHTML: "INFO",
                 style: {
                     ...cssLabel,
                     fontSize: Scale.Wpx(75)
                 }
             });
     
             this.attendantElem = CreateElement("div", {
                 classes: ["but-attendant", "button"],
                 parentToAppend: miniMenu,
                 style: {
                     ...cssButton,
                     width: Scale.Wpx(120*2),
                     height: Scale.Hpx(100*2),
                 }
             });
     
     
             let btnAttendantLabel = CreateElement("div", {
                 classes: ["but-attendant-label", "label"],
                 parentToAppend: this.attendantElem,
                 childToAppend: this.translator.Anchor(() => this.translator.t.callAttendant),
                 style: {
                     ...cssLabel,
                     lineHeight: "initial",//Scale.fhpx(30),
                     fontSize: Scale.fhpx(37.5),
                 }
             });
     
     
             // LEFT GROUP
             let grpLeft = CreateElement("div", {
                 classes: ["but-vertical-group", "but-left-group"], parentToAppend: this.view, style: {
                     ...cssVerticalGroup,
                     width: "37.5%",
     
                 }
             });
     
             let btnLines = CreateElement("div", {
                 classes: ["but-lines", "button"], parentToAppend: grpLeft, style: {
                     //height: Scale.Hpx(35),
                     //position: "relative",
                     //left: "-224px",
                     //background: "transparent",
                     //...cssButton
                     display: "flex",
                     //alignItems: "center",
                     justifyContent: "center",
                     width: "100%"
                 }
             });
     
             this.linesDenomMessage = this.translator.Translate(() => this.translator.t.playingDenomOnLines(this.denom, this.lines));
             let btnLinesValue = CreateElement("div", {
                 classes: ["but-lines-value", "message-value"],
                 parentToAppend: btnLines,
                 childToAppend: this.linesDenomMessage.location,
                 style: {
                     //...cssMessageValue
                     //display: "flex",
                     // justifyContent: "center",
                     // alignItems: "center",
                     fontSize: Scale.fhpx(20),
     
                     color: "white",
                     textShadow: "0 0 10px black",
                     background: "transparent",
                     //position: "absolute",
                     // top: "8px",
                     // left: Scale.Hpx(360),
                 }
             });
     
             let grpDenomBalance = CreateElement("div", {
                 classes: ["but-horizontal-group", "but-group-denom-balance"], parentToAppend: grpLeft, style: {
                     ...cssHorizontalGroup,
                     //flexGrow: "1"
                     justifyContent: "space-evenly",
                     alignItems: "flex-end",
                     height: "100%",
                 }
             });
     
             // grpDenomBalance.addEventListener("mouseenter", () => this.HidePopUp());
     
             this.butcash = CreateElement("div", {
                 classes: ["but-cash", "button"],
                 parentToAppend: grpDenomBalance,
                 style: {
                     ...cssButton,
                     width: Scale.Wpx(120)//Scale.Wpx(100),
                     // height: Scale.Hpx(70),
                     //position: "absolute",
                 }
             });
     
             let btnCashLabel = CreateElement("div", {
                 classes: ["but-cash-label", "label"],
                 parentToAppend: this.butcash,
                 childToAppend: this.translator.Anchor(() => this.translator.t.collect),
                 style: {
                     ...cssLabel
                 }
             });
     
             let popUpBtn = CreateElement("div", {
                classes: ["pop-up-btn"],
                 parentToAppend: grpDenomBalance,
                 style:{
                     ...cssButton,
                     width: Scale.Wpx(120),
                 }
     
                 // mousedown: () => {
                 //     this.ShowPopUp();
                 // }
             })

             let popUpMenuBtnlabel = CreateElement("div",
             {
                 classes: ["popup-menu", "options"],
                 parentToAppend: popUpBtn,
                 childToAppend: this.translator.Anchor(() => this.translator.t.optionsbtntxt),
                 style: {
                     ...cssLabel,
                     marginBottom: Scale.Ypx(10),
                 }
 
             });
     
             let settingsIconDiv = CreateElement("div", {
                 parentToAppend: popUpBtn,
                innerHTML: SettingsIconMap["SettingsIcon1"],
                 style: {
                     ...SvgIcon
     
                 }
             })
     
             this.btnBalance = CreateElement("div", {
                 classes: ["but-credit", "button"], parentToAppend: grpDenomBalance, style: {
                     position: "relative",
                     //left: "80px",
                     width: Scale.Wpx(220),
                     ...cssButton
                 }
             });
             let btnBalanceLabel = CreateElement("div", {
                 classes: ["but-credit-label", "label"],
                 parentToAppend: this.btnBalance,
                 childToAppend: this.translator.Anchor(() => this.translator.t.balance),
                 style: {
                     ...cssLabel
                 }
             });
     
             this.balanceCurrency = CreateElement("div", {
                 classes: ["but-credit-currency", "currency"], parentToAppend: this.btnBalance, style: {
                     ...cssCurrency
                 }
             });
             let btnBalanceCurrencyValue = CreateElement("span", { classes: ["but-credit-currency-value"], parentToAppend: this.balanceCurrency, innerHTML: "123,456.00" });
             this.balanceCredits = CreateElement("div", {
                 classes: ["but-credit-credit", "credit"], parentToAppend: this.btnBalance, innerHTML: "123456", style: {
                     ...cssCredit
                 }
             });
             let btnBalanceLinear = CreateElement("div", {
                 classes: ["linear"], parentToAppend: this.btnBalance, style: {
                     ...cssLinear
                 }
             });
     
             let btnTotalbet = CreateElement("div", {
                 classes: ["but-totalbet", "button"], parentToAppend: grpDenomBalance, style: {
                     //alignSelf: "flex-end",
                     //flexGrow: "1",
                     position: "relative",
                     //left: "127px",
                     width: Scale.Wpx(122),
                     ...cssButton
                 }
             });
             this.butTotalBet = btnTotalbet;
             let btnTotalbetLabel = CreateElement("div", {
                 classes: ["but-totalbet-label", "label"],
                 parentToAppend: btnTotalbet,
                 childToAppend: this.translator.Anchor(() => this.translator.t.tbet),
                 style: {
                     ...cssLabel
                 }
             });
             this.totalBetCurrency = CreateElement("div", {
                 classes: ["but-totalbet-currency", "currency"], parentToAppend: btnTotalbet, innerHTML: "123.00", style: {
                     ...cssCurrency
                 }
             });
             // TODO span
             this.totalBetCredits = CreateElement("div", {
                 classes: ["but-totalbet-credit", "credit"], parentToAppend: btnTotalbet, innerHTML: "123", style: {
                     ...cssCredit
                 }
             });
             let btnTotalbetLinear = CreateElement("div", {
                 classes: ["linear"], parentToAppend: btnTotalbet, style: {
                     ...cssLinear
                 }
             });
     
             let btnPerLine = CreateElement("div", {
                 classes: ["but-betperline", "button"],
                 parentToAppend: grpDenomBalance,
                 style: {
                     alignSelf: "flex-end",
                     flexGrow: "1",
                     ...cssButton,
                     display: "none",
                 }
             });
             let btnPerLineLabel = CreateElement("div", {
                 classes: ["but-betperline-label", "label"],
                 parentToAppend: btnPerLine,
                 childToAppend: this.translator.Anchor(() => this.translator.t.tline),
                 style: {
                     ...cssLabel
                 }
             });
             this.betCredits = CreateElement("div", {
                 classes: ["but-betperline-credit", "credit"],
                 parentToAppend: btnPerLine,
                 innerHTML: "123",
                 style: {
                     ...cssCredit
                 }
             });
             this.betCurrency = CreateElement("div", {
                 classes: ["but-betperline-currency", "currency"],
                 parentToAppend: btnPerLine,
                 style: {
                     ...cssCurrency
                 }
             });
     
             let centerCol = CreateElement("div", {
                 classes: ["but-vertical-group"],
                 parentToAppend: this.view,
                 style: {
                     ...cssVerticalGroup,
                     width:"25%"
                 }
             });
     
             let butWin = CreateElement("div", {
                 classes: ["but-win", "button"],
                 parentToAppend: centerCol,
                 style: {
                     position: "relative",
                     ...cssButton,
                     margin: "",
                     marginTop: Scale.Xpx(23),
                     height: Scale.Wpx(135),
                    //  flexGrow: "1",
                 }
             });

            this.freeRoundsRemainingText = this.translator.Translate(() => {

                let remaining = 0;
                
                if (this.freeRoundsStats)
                {
                    remaining = this.freeRoundsStats.FreeRoundsNumber - this.freeRoundsStats.PlayedFreeRoundsNumber;
                }

                return this.translator.t.freerRoundCounterText(remaining)
            });

            this.freeRoundsRemaining = CreateElement("div", {
                classes: ["free-spins-remaining", "label"],
                parentToAppend: butWin,
                childToAppend: this.freeRoundsRemainingText.location,
                style: {
                    fontSize: Scale.fhpx(30),
                    lineHeight: "0px",
                    position: "absolute",
                    top: "-15px",
                    alignSelf: "center",
                    display:"none",
                    //borderRadius: Scale.XYpx(16),

                    //border: `${Scale.XYpx(4)} solid gold`,
                    //borderStyle: "inset",

                    margin: `${Scale.Wpx(5)} ${Scale.Hpx(10)}`,
                    color: "white",

                }
            });
     
             let butWinLabel = CreateElement("div", {
                 classes: ["but-win-label", "label"],
                 parentToAppend: butWin,
                 style: {
                     fontSize: Scale.fhpx(30),
                     lineHeight: "0px",
                     ...cssLabel
                 }
             });
     
             this.winCurrency = CreateElement("div", {
                 classes: ["but-win-currency", "currency"],
                 parentToAppend: butWin,
                 style: {
                     fontSize: Scale.fhpx(40),
                     textAlign: "center",
                     color: "yellow",
                     textShadow: "0 0 10px black",
                     position: "relative",
                     top: Scale.Ypx(30),
                     //...cssCurrency
                 }
             });
     
             this.winCredits = CreateElement("div", {
                 classes: ["but-win-credit", "credit"],
                 parentToAppend: butWin,
                 style: {
                     ...cssCredit,
                     fontSize: Scale.fhpx(60),
                     lineHeight: Scale.Hpx(100),
                     marginTop: Scale.Ypx(2),
                 }
             });
     
             let butWinLinear = CreateElement("div", {
                 classes: ["linear"],
                 parentToAppend: butWin,
                 style: {
                     ...cssLinear,
     
     
                 }
             });
     
             let grpRight = CreateElement("div", {
                 classes: ["but-vertical-group", "but-right-group"],
                 parentToAppend: this.view,
                 style: {
                     ...cssVerticalGroup,
                     width: "37.5%",
                 }
             });
     
             this.messageElem = CreateElement("div", {
                 classes: ["but-message", "button", "message-value", "message"],
                 parentToAppend: grpRight,
                 style: {
                     //height: Scale.Hpx(35),
                     //position: "relative",
                     //left: "-30px",
                     //...cssButton,
                     display: "flex",
                     justifyContent: "center",
                     width: "100%",
                     // alignItems: "center",
                     //top: "8px",
                     //right: Scale.Hpx(70),
                     
                     fontSize: Scale.fhpx(20),
                     color: "white",
                     textShadow: `0 0 ${Scale.XYpx(10)} black`,
                     background: "transparent",
     
                 }
             });
     
     
             let grpRightHorizontal = CreateElement("div", {
                 classes: ["but-horizontal-group", "but-group-autoplay-maxbet-spin"],
                 parentToAppend: grpRight,
                 style: {
                     ...cssHorizontalGroup,
                     //flexGrow: "1"
                     justifyContent: "space-evenly",
                     alignItems: "flex-end",
                     height: "100%",
                 }
             });
     
             // grpRightHorizontal.addEventListener("mouseenter", () => this.HidePopUp());
     
             // let grpAutoplayMaxbet = CreateElement("div", {
             //     classes: ["but-horizontal-group", "but-group-autoplay-maxbet"],
             //     parentToAppend: grpRight,
             //     style: {
             //         ...cssHorizontalGroup,
             //         //flexGrow: "1"
             //         justifyContent: "space-evenly",
             //         alignItems: "flex-end",
             //         height: "100%",
     
             //     }
             // });
     
             this.butAutoplay = CreateElement("div", {
                 classes: ["but-auto-play", "button"],
                 parentToAppend: grpRightHorizontal,
                 style: {
                     //flexGrow: "1",
                     // alignSelf: "flex-end",
                     ...cssButton,
                     width: Scale.Wpx(130),
                     //display: "none",
                 }
             });
     
             let butAutplayLabel = CreateElement("div", {
                 classes: ["but-auto-play-label", "label"],
                 parentToAppend: this.butAutoplay,
                 childToAppend: this.translator.Anchor(() => this.translator.t.auto),
                 style: {
                     ...cssLabel,
                     margin: Scale.XYpx(7),
                     lineHeight: Scale.fhpx(20),
                     display: "block",
                 }
             });

             this.btnChangeBetType = CreateElement("div", {
                classes: ["but-bet", "button"],
                parentToAppend: grpRightHorizontal,
                style: {
                    position: "relative",
                    //left: "80px",
                    width: Scale.Wpx(190),
                    ...cssButton1
                }
            });
            this.betTypeLabel = CreateElement("div", {
                classes: ["but-bet-type"],
                parentToAppend: this.btnChangeBetType,
                style: {
                    ...this.cssLabel,
                    lineHeight: Scale.fhpx(20),
                },
                childToAppend: this.translator.Anchor(() => this.translator.t.buyBonusButton),
            });
            // let betTypeValue = CreateElement("span", { classes: ["but-bet-type"], parentToAppend: this.betTypeLabel, innerHTML: "BUY" });
            // this.betValue = CreateElement("div", {
            //     classes: ["but-bet-value"],
            //     parentToAppend: this.btnChangeBetType,
            //     innerHTML: "BONUS",
            //     style: {
            //         ...this.cssLabel
            //     }
            // });

        this.butMaxBet = CreateElement("div", {
            classes: ["but-max-bet", "button"],
            parentToAppend: grpRightHorizontal,
            style: {
                //flexGrow: "1",

                // alignSelf: "flex-end",

                ...cssButton,


                width: Scale.Wpx(170),
            }
        })

        let butMaxBetLabel = CreateElement("div", {
            classes: ["but-max-bet-label", "label"],
            parentToAppend: this.butMaxBet,
            childToAppend: this.translator.Anchor(() => this.translator.t.maxbet),
            style: {
                ...cssLabel,
                marginTop: Scale.Ypx(21),
                lineHeight: Scale.Hpx(20),
                display: "block"
            }
        });

        let butMaxBetLinear = CreateElement("div", {
            classes: ["linear"],
            parentToAppend: this.butMaxBet,
            style: {
                ...cssLinear,
                marginTop: Scale.Ypx(20),
            }
        });

        this.butSpin = CreateElement("div", {
            classes: ["but-spin", "button"],
            parentToAppend: grpRightHorizontal,
            style: {
                width: Scale.Wpx(300),
                alignSelf: "flex-end",
                ...cssButton,
                position: "relative"
            }
        });

        if (this.params.doubleupEnabled) {
            this.butDoubleUp = CreateElement("div", {
                classes: ["but-gamble", "button"],
                parentToAppend: grpRightHorizontal,
                style: {
                    width: Scale.Wpx(100),
                    alignSelf: "flex-end",
                    ...cssButton,
                    position: "relative"
                }
            });
        }

        // <div class="but-turbo-label">Hold for turbo</div>
        this.turboElem = CreateElement("div", {
            classes: ["but-turbo-label"],
            parentToAppend: this.butSpin,
            innerHTML: "Hold for turbo",
            style: {
                //position: "absolute",
                top: Scale.Ypx(10),
                width: "100%",
                fontSize: Scale.fhpx(12),
                color: "white",
                textAlign: "center",
                textShadow: "#001 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px",
            }
        });

        this.spinElem = CreateElement("div", {
            classes: ["but-spin-label", "label"],
            parentToAppend: this.butSpin,
            style: {
                ...cssLabel,
                fontSize: Scale.fhpx(40),
                lineHeight: Scale.Hpx(85)

            }
        });

        if (this.params.doubleupEnabled) {
            let doubleuplabel = CreateElement("div", {
                classes: ["but-gamble-label", "label"],
                parentToAppend: this.butDoubleUp,
                childToAppend: this.translator.Anchor(() => this.translator.t.doubleup),
                style: {
                    ...cssLabel,
                    marginTop: Scale.Ypx(10),
                    lineHeight: Scale.Hpx(20)

                }
            });
        }


        let btnSpinLinear = CreateElement("div", {
            classes: ["linear"], parentToAppend: this.butSpin, style: {
                ...cssLinear
            }
        });

        // let rightCol = CreateElement("div", {
        //     classes: ["but-vertical-group", "but-group-help-games"],
        //     parentToAppend: this.view,
        //     style: {
        //         ...cssVerticalGroup
        //     }
        // });

        this.butMenu = CreateElement("div", {
            classes: ["but-games", "button"],
            parentToAppend: grpRightHorizontal,
            style: {
                ...cssButton,
                // ...cssLeftRightButton,
                width: Scale.Wpx(170),
            }
        });
        let butMenuLabel = CreateElement("div", {
            classes: ["but-games-icon", "label"],
            parentToAppend: this.butMenu,
            childToAppend: this.translator.Anchor(() => this.translator.t.menu),
            style: {
                ...cssLabel,
                lineHeight: Scale.fhpx(23),


            }
        });
     
        if (this.backendSettings?.GetBool("accounting.payoutButton")) {
            // this.ConstructButton(Button.ButtonPayout, this.butcash);
            this.butcash.style.visibility = "visible";
        }
        else {
            this.butcash.style.visibility = "hidden"
        }

        this.ConstructButton(Button.ButtonSettings, popUpBtn);
        //  this.GetDefaultReelSpeed();

    }


	protected IdleAnim()
	{
        // return;

		// this.idleAnimState = !this.idleAnimState;

		// if(this.idleAnimState)
		// {
		// 	// on
		// 	this.butElem.get(PanelButton.Spin).style.boxShadow= "0 0px 16px  rgb(0, 255, 0)";
		// 	this.butElem.get(PanelButton.Spin).style.backgroundColor= "rgb(0, 255, 0)";
		// }
		// else
		// {
		// 	// off
		// 	this.butElem.get(PanelButton.Spin).style.boxShadow= "none";
		// 	this.butElem.get(PanelButton.Spin).style.backgroundColor= "transparent";
		// }

		// //this.turboAnimState = !this.turboAnimState;
		// this.turboElem.style.color = this.idleAnimState ? "white" : "red";
	}

	protected IdleAnimStart()
	{
		this.idleAnim.Start();
	}

	protected IdleAnimStop()
	{

		this.idleAnim.Stop();


		// off
		this.idleAnimState = false;
		this.butElem.get(Button.ButtonSpin).style.boxShadow= "none";
		//this.butElem.get(PanelButton.Spin).style.backgroundColor= "transparent";

		//this.turboAnimState = false;
		this.turboElem.style.color = "white";
	}

	

	public PrepareResources(resourceManager: IWriteOnlyResourceManager) {
		//resourceManager.Add(new HTMLResource(this.resourcePath + "panel.html", this.resid.ScopedResourceName("html")));
		//resourceManager.Add(new CSSResource(this.resourcePath + "panel.css", this.resid.ScopedResourceName("css"), this.resid.CSSScope()));
 
		resourceManager.Add(new ImageResource(this.resourcePath + "volume_0.png", this.resid.ScopedResourceName(["volume0", "image"])));
		resourceManager.Add(new ImageResource(this.resourcePath + "volume_1.png", this.resid.ScopedResourceName(["volume1", "image"])));
		resourceManager.Add(new ImageResource(this.resourcePath + "volume_2.png", this.resid.ScopedResourceName(["volume2", "image"])));
		resourceManager.Add(new ImageResource(this.resourcePath + "volume_3.png", this.resid.ScopedResourceName(["volume3", "image"])));
		
		
		this.audio.AddTrack(new Track(this.resourcePath + "turbostart" + Settings.audioFormat, this.resid.ScopedResourceName("turbostart"), false));
		this.audio.AddTrack(new Track(this.resourcePath + "turbostop" + Settings.audioFormat, this.resid.ScopedResourceName("turbostop"), false));
		//resourceManager.Add(new FontResource("./Panel/huggable.ttf", "panel.font"));

        this.CallAttendantPrepare();
	}
    //protected panelElements: HTMLElement[]=[];
    

    protected butSpin: HTMLElement;
    protected butTotalBet: HTMLElement;
    protected butVolume: HTMLElement;
    protected butDenom: HTMLElement;
    protected butMaxBet: HTMLElement;
    protected butAutoplay: HTMLElement;
    protected butHelp: HTMLElement;
    protected butMenu: HTMLElement;
    protected butcash : HTMLElement;
    protected btnBalance : HTMLElement;
    protected butDoubleUp: HTMLElement;
    protected btnChangeBetType : HTMLElement;

    protected cssLabel: Partial<CSSStyleDeclaration>  = {
        fontSize: Scale.fhpx(20),
        lineHeight: "0px",
        //color: "white",
        textAlign: "center",
        
    
        fontFamily: "NotoSansDisplay-Bold",
        fontWeight: "bold", 
        
        color: "white",
        textShadow: Array(Math.round(Scale.XY(18))).fill("#001 0px 0px 4px").join(", ") //.repeat() #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px",
    };
    

    


    


    protected lines: number = 0;
    protected denom: string = "1";
    protected linesDenomMessage: TranslatedLocation;

    public ConstructHtml()
    {
        if (Settings.EnablePanelWithSettings)
        {
            this.ConstructHtmlWithSettingsBtn()
            return;
            
        }

        let cssLinear: Partial<CSSStyleDeclaration> = {
            borderWidth: Scale.XYpx(5),
            borderStyle: "solid",
            position: "relative",
            margin: "0px auto",
            bottom: Scale.Ypx(5),
            filter: `blur(${Scale.XYpx(2)})`,
            width: "80%",
            borderImage: this.ButtonBackground().linearColor
           
        };

        let cssVerticalGroup: Partial<CSSStyleDeclaration> = {
            display: "flex",
            flexDirection: "column",
            //justifyContent: "flex-end",
        };

        let cssHorizontalGroup: Partial<CSSStyleDeclaration> = {
            display: "flex",
            flexDirection: "row",
            flexGrow: "1",
            alignItems: "end",
        };

        let cssLeftRightButton: Partial<CSSStyleDeclaration> = {
            flexGrow: "1",
            height: Scale.Hpx(47),
            width: Scale.Wpx(85),
        };

        let cssButton: Partial<CSSStyleDeclaration> = {
            borderRadius: Scale.XYpx(16),
    
            border: `${Scale.XYpx(7)} solid transparent`,
            //backgroundClip: "padding-box",
            borderStyle: "inset",
        
            margin: `${Scale.Wpx(5)} ${Scale.Hpx(10)}`,
            height: Scale.Hpx(100),
        
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-evenly",
        
            backgroundOrigin: "border-box",
            backgroundClip: "content-box, border-box",
            backgroundImage: this.ButtonBackground().backgroundButtonColor
        };
        let color1: ButtonColors = {
            backgroundButtonColor: "linear-gradient(rgb(139, 0, 0), rgb(178, 34, 34), rgb(139, 0, 0)), linear-gradient(#BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
            linearColor: "linear-gradient(to left, transparent, LightGoldenrodYellow, transparent) 0 10 100%",
        };
        
        let cssButton1: Partial<CSSStyleDeclaration> = {
            borderRadius: Scale.XYpx(16),
    
            border: `${Scale.XYpx(7)} solid transparent`,
            //backgroundClip: "padding-box",
            borderStyle: "inset",
        
            margin: `${Scale.Wpx(5)} ${Scale.Hpx(10)}`,
            height: Scale.Hpx(100),
        
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-evenly",
        
            backgroundOrigin: "border-box",
            backgroundClip: "content-box, border-box",
            backgroundImage: color1.backgroundButtonColor,
        };

            this.cssLabel = {
            fontSize: Scale.fhpx(20),
            lineHeight: "0px",
            //color: "white",
            textAlign: "center",
            
        
            fontFamily: "NotoSansDisplay-Bold",
            fontWeight: "bold", 
            
            color: "white",
            textShadow: Array(Math.round(Scale.XY(18))).fill("#001 0px 0px 4px").join(", ") //.repeat() #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px",
        };
    
        let cssMessageValue: Partial<CSSStyleDeclaration> = {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontSize: Scale.fhpx(20),
        
            color: "white",
            textShadow: "0 0 10px black",
            background: "transparent",
            position: "relative",
            top:"0px",
           
        };

        let cssCredit: Partial<CSSStyleDeclaration> = {
            fontSize: Scale.fhpx(35),
            lineHeight: Scale.Hpx(40),
            textAlign: "center",
            height: "100%",
        
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
        
            color: "white",
        
            textShadow: `0 0 ${Scale.XYpx(10)} black`,
            position: "relative",
            top: Scale.Ypx(6),
        };

        let cssCurrency: Partial<CSSStyleDeclaration> = {
            fontSize: Scale.fhpx(25),
            textAlign: "center",
            color: "yellow",
            textShadow: `0 0 ${Scale.XYpx(10)} black`,
            position: "relative",
            top: Scale.Ypx(12),
            left: Scale.Ypx(0),
            margin: Scale.Ypx(0),
        }

        /* #region Left column */
        let leftCol = CreateElement("div", {
            classes: ["but-vertical-group", "but-group-value-collect"],
            parentToAppend: this.view,
            style: {
                ...cssVerticalGroup
            }
        });

            this.butVolume = CreateElement("div", {
                classes: ["but-vol", "button"],
                parentToAppend: leftCol,
                style: {
                    ...cssButton,
                    ...cssLeftRightButton,
                }
            });

                this.butVolLabel = CreateElement("div", {
                    classes: ["but-vol-value", "label"],
                    parentToAppend: this.butVolume,
                    style: {
                        ...this.cssLabel
                    }
                });
        
            this.butDenom = CreateElement("div", {
                classes: ["but-denom", "button"],
                parentToAppend: leftCol,
                style: {                   
                    ...cssButton,
                    ...cssLeftRightButton,
                }
            });

                this.denomElem = CreateElement("div", {
                    classes: ["denom-value", "message-value"],
                    parentToAppend: this.butDenom,
                    style: {
                        ...cssMessageValue
                    }
                });

                    let butDenomDenom = CreateElement("div", {
                        classes: ["denom-denom"],
                        parentToAppend: this.denomElem
                    });

        /* #endregion */

        //this.view.innerHTML += 
        // `
        // <!-- new panel -->
        // <div class="but-vertical-group but-group-value-collect">
        //     <div class="but-vol button">
        //         <span class="but-vol-value label">
        //         </span>
        //     </div>
        
        //     <!--
        //     <div class="but-collect button">
        //         <span class="but-collect-value label">COLLECT</span>
        //     </div>
        //     -->
        //     <div class="but-denom button">
        //         <div class="denom-value message-value"><span class="denom-denom"></span></div>
        //     </div>
        // </div>`
        
        
        // `<div class="but-horizontal-group but-left-group">
        //     <div class="but-vertical-group but-group-denom-balance">
        
        
        //         <div class="but-credit button">
        //             <div class="but-credit-label label">
        
        //             </div>
        //             <div class="but-credit-currency currency">
        //                 <span class="but-credit-currency-value">123,456.00</span>
        //                 <!--<span class="but-credit-currncy-icon"></span>-->
        //             </div>
        //             <div class="but-credit-credit credit">123456</div>
        
        //             <div class="linear"> </div>
        //         </div>
        //     </div>
        
        //     <div class="but-vertical-group but-group-lines-totalbet">
        //         <div class="but-lines button " style="border: hidden; box-shadow: none;">
        //             <div class="but-lines-value message-value"><span class="playinon"> </span>&nbsp;<span
        //                     class="selected-lines"></span>&nbsp;
        //                 <span class="lines"></span></div>
        //         </div>
        
        //         <div class="but-horizontal-group">
        
        //             <div class="but-totalbet button">
        
        //                 <div class="but-totalbet-label label"></div>
        //                 <div class="but-totalbet-currency currency">
        //                     <span class="but-totalbet-currency-value">123.00</span>
        //                     <!--<span class="but-totalbet-currency-symbol"></span>-->
        //                 </div>
        
        //                 <div class="but-totalbet-credit credit">123</div>
        //                 <div class="linear"> </div>
        
        //             </div>
        
        //             <div class="but-betperline button" style="visibility: hidden;">
        //                 <div class="but-betperline-label label"></div>
        //                 <div class="but-betperline-credit credit">123</div>
        //                 <div class="but-betperline-currency currency">
        //                     <span class="but-betperline-currency-value">123.00</span>
        //                     <!--<span class="but-betperline-currency-symbol"></span>-->
        //                 </div>
        //             </div>
        //         </div>
        //     </div>
        
        
        // </div>`;

         /* #region Left column */
         let leftCol2 = CreateElement("div", {
            classes: ["but-vertical-group", "but-group-payout-attendant"],
            parentToAppend: this.view,
            style: {
                ...cssVerticalGroup
            }
        });


        this.butcash = CreateElement("div", {
            classes: ["but-cash", "button"],
            parentToAppend: leftCol2,
            style: {
                ...cssButton,
                width: Scale.Wpx(100),
                height: Scale.Hpx(70),
                //position: "absolute",
            }
        });

            if (this.backendSettings?.GetBool("accounting.payoutButton"))
            {
                this.butcash.style.visibility = "visible";
            }
            else
            {
                this.butcash.style.visibility = "hidden"
            }

            let btnCashLabel = CreateElement("div", {
                classes: ["but-cash-label", "label"],
                parentToAppend: this.butcash,
                childToAppend: this.translator.Anchor(() => this.translator.t.collect),
                style: {
                    ...this.cssLabel
                }
            });


        
            
         this.attendantElem = CreateElement("div", {
            classes: ["but-attendant", "button"],
            parentToAppend: leftCol2,
            style: {
                ...cssButton,
                width: Scale.Wpx(100),
                height: Scale.Hpx(70),
                //position: "absolute",
            }
        });


        let btnAttendantLabel = CreateElement("div", {
            classes: ["but-attendant-label", "label"],
            parentToAppend: this.attendantElem,
            childToAppend: this.translator.Anchor(() => this.translator.t.callAttendant),
            style: {
                ...this.cssLabel,
                lineHeight : Scale.fhpx(30),
                fontSize : Scale.fhpx(15),
            }
        });
        

        // LEFT GROUP
        let grpLeft = CreateElement("div", {classes: ["but-vertical-group", "but-left-group"], parentToAppend: this.view, style: {
            ...cssVerticalGroup,
            width: "100%"
        }});
        let btnLines = CreateElement("div", {
            classes: ["but-lines", "button"], parentToAppend: grpLeft, style: {
                height: Scale.Hpx(35),
                //position: "relative",
                //left: "-224px",
                //background: "transparent",
                //...cssButton
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            }
        });

        this.linesDenomMessage = this.translator.Translate(() => this.translator.t.playingDenomOnLines(this.denom, this.lines));
        let btnLinesValue = CreateElement("div", {
            classes: ["but-lines-value", "message-value"],
            parentToAppend: btnLines,
            childToAppend: this.linesDenomMessage.location,
            style: {
                //...cssMessageValue
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                fontSize: Scale.fhpx(20),

                color: "white",
                textShadow: "0 0 10px black",
                background: "transparent",
                position: "absolute",
                top: "8px",
                left: Scale.Hpx(360),
            }
        });

        let grpDenomBalance = CreateElement("div", {
            classes: ["but-horizontal-group", "but-group-denom-balance"], parentToAppend: grpLeft, style: {
                ...cssHorizontalGroup,
                //flexGrow: "1"
                justifyContent: "space-evenly",
                alignItems: "flex-end",
                height: "100%",
            }
        });

        // this.butcash = CreateElement("div", {
        //     classes: ["but-cash", "button"],
        //     parentToAppend: grpDenomBalance,
        //     style: {
        //         ...cssButton,
        //         width: Scale.Wpx(100),
        //         height: Scale.Hpx(70),
        //         //position: "absolute",
        //     }
        // });

        // if(Settings.PayoutButtonEnabled == true){
        //     this.butcash.style.display = "flex";
        // }
        // else{
        //     this.butcash.style.display ="none"
        // }


        // let btnCashLabel = CreateElement("div", {
        //     classes: ["but-cash-label", "label"],
        //     parentToAppend: this.butcash,
        //     childToAppend: this.translator.Anchor(() => this.translator.t.collect),
        //     style: {
        //         ...cssLabel
        //     }
        // });
        // if (this.buyBonusIsEnabledForAny) {
        //     this.btnChangeBetType = CreateElement("div", {
        //         classes: ["but-bet", "button"], parentToAppend: grpDenomBalance, style: {
        //             position: "relative",
        //             //left: "80px",
        //             width: Scale.Wpx(220),
        //             ...cssButton
        //         }
        //     });
        //     this.betTypeLabel = CreateElement("div", {
        //         classes: ["but-bet-type"],
        //         parentToAppend: this.btnChangeBetType,
        //         style: {
        //             ...this.cssLabel
        //         }
        //     });
        //     let betTypeValue = CreateElement("span", { classes: ["but-bet-type"], parentToAppend: this.betTypeLabel, innerHTML: "BUY" });
        //     this.betValue = CreateElement("div", {
        //         classes: ["but-bet-value"],
        //         parentToAppend: this.btnChangeBetType,
        //         innerHTML: "BONUS",
        //         style: {
        //             ...this.cssLabel
        //         }
        //     });
        // }
            this.btnBalance = CreateElement("div", {
                classes: ["but-credit", "button"], parentToAppend: grpDenomBalance, style: {
                    position: "relative",
                    //left: "80px",
                    width: Scale.Wpx(220),
                    ...cssButton
                }
            });
            let btnBalanceLabel = CreateElement("div", {
                classes: ["but-credit-label", "label"],
                parentToAppend: this.btnBalance,
                childToAppend: this.translator.Anchor(() => this.translator.t.balance),
                style: {
                    ...this.cssLabel
                }
            });

            this.balanceCurrency = CreateElement("div", {
                classes: ["but-credit-currency", "currency"], parentToAppend: this.btnBalance, style: {
                    ...cssCurrency
                }
            });
            let btnBalanceCurrencyValue = CreateElement("span", { classes: ["but-credit-currency-value"], parentToAppend: this.balanceCurrency, innerHTML: "123,456.00" });
            this.balanceCredits = CreateElement("div", {
                classes: ["but-credit-credit", "credit"], parentToAppend: this.btnBalance, innerHTML: "123456", style: {
                    ...cssCredit
                }
            });
            let btnBalanceLinear = CreateElement("div", {
                classes: ["linear"], parentToAppend: this.btnBalance, style: {
                    ...cssLinear
                }
            });
            // let grpLinesTotalbet = CreateElement("div", {classes: ["but-vertical-group", "but-group-lines-totalbet"], parentToAppend: grpLeft, style: {
            //     ...cssVerticalGroup,
            //     justifyContent: "space-evenly"
            // }});

                        // TODO some spans, not needed 
                // let grpTotalPerLine = CreateElement("div", {classes: ["but-horizontal-group"], parentToAppend: grpDenomBalance, style: {
                //     ...cssHorizontalGroup
                // }});
                    let btnTotalbet = CreateElement("div", {classes: ["but-totalbet", "button"], parentToAppend: grpDenomBalance, style: {
                        //alignSelf: "flex-end",
                        //flexGrow: "1",
                        position: "relative",
                        //left: "127px",
                        width: Scale.Wpx(122),
                        ...cssButton
                    }});
                    this.butTotalBet = btnTotalbet;
                        let btnTotalbetLabel = CreateElement("div", {
                            classes: ["but-totalbet-label", "label"], 
                            parentToAppend: btnTotalbet, 
                            childToAppend: this.translator.Anchor(() => this.translator.t.tbet),
                            style: {
                                ...this.cssLabel
                            }
                        });
                        this.totalBetCurrency = CreateElement("div", {classes: ["but-totalbet-currency", "currency"], parentToAppend: btnTotalbet, innerHTML: "123.00", style: {
                            ...cssCurrency
                        }});
                            // TODO span
                        this.totalBetCredits = CreateElement("div", {classes: ["but-totalbet-credit", "credit"], parentToAppend: btnTotalbet, innerHTML: "123", style: {
                            ...cssCredit
                        }});
                        let btnTotalbetLinear = CreateElement("div", {classes: ["linear"], parentToAppend: btnTotalbet, style: {
                            ...cssLinear
                        }});

                    let btnPerLine = CreateElement("div", {
                        classes: ["but-betperline", "button"], 
                        parentToAppend: grpDenomBalance, 
                        style: {
                            alignSelf: "flex-end",
                            flexGrow: "1",
                            ...cssButton,
                            display: "none",
                        }
                    });
                        let btnPerLineLabel = CreateElement("div", {
                            classes: ["but-betperline-label", "label"], 
                            parentToAppend: btnPerLine, 
                            childToAppend: this.translator.Anchor(() => this.translator.t.tline),
                            style: {
                                ...this.cssLabel
                            }
                        });
                        this.betCredits = CreateElement("div", {
                            classes: ["but-betperline-credit", "credit"], 
                            parentToAppend: btnPerLine, 
                            innerHTML: "123", 
                            style: {
                                ...cssCredit
                            }
                        });
                        this.betCurrency = CreateElement("div", {
                            classes: ["but-betperline-currency", "currency"], 
                            parentToAppend: btnPerLine, 
                            style: {
                                ...cssCurrency
                            }
                        });
                        // TODO span

        //this.butTotalBet = this.view.querySelector(".but-totalbet");
         
        // this.view.innerHTML += `<div class="but-vertical-group">
        
        //     <div class="but-win button">
        //         <div class="but-win-label label"></div>
        //         <div class="but-win-currency currency">
        //             <span class="but-win-currency-value">123,456.00</span>
        //             <!--<span class="but-win-currncy-icon">MXN</span>-->
        //         </div>
        //         <div class="but-win-credit credit">999999</div>
        //         <div class="linear"></div>
        //     </div>
        // </div>`;

        

        let centerCol = CreateElement("div", {
            classes: ["but-vertical-group"],
            parentToAppend: this.view,
            style: {
                ...cssVerticalGroup
            }
        });

            let butWin = CreateElement("div", {
                classes: ["but-win", "button"],
                parentToAppend: centerCol,
                style: {
                    position: "relative",
                    ...cssButton,
                    width: Scale.Wpx(480),
                    flexGrow: "1",
                    alignItems:"center"
                }
            });

                this.freeRoundsRemainingText = this.translator.Translate(() => {

                    let remaining = 0;
                    
                    if (this.freeRoundsStats)
                    {
                        remaining = this.freeRoundsStats.FreeRoundsNumber - this.freeRoundsStats.PlayedFreeRoundsNumber;
                    }

                    return this.translator.t.freerRoundCounterText(remaining)
                });
                this.freeRoundsRemaining = CreateElement("div", {
                    classes: ["free-spins-remaining", "label"],
                    parentToAppend: butWin,
                    childToAppend: this.freeRoundsRemainingText.location,
                    style: {
                        fontSize: Scale.fhpx(30),
                        lineHeight: "0px",
                        position: "absolute",
                        top: "-15px",
                        alignSelf: "center",
                        //borderRadius: Scale.XYpx(16),

                        //border: `${Scale.XYpx(4)} solid gold`,
                        //borderStyle: "inset",

                        margin: `${Scale.Wpx(5)} ${Scale.Hpx(10)}`,
                        color: "white",
                    }
                });

                let butWinLabel = CreateElement("div", {
                    classes: ["but-win-label", "label"],
                    parentToAppend: butWin,
                    style: {
                        fontSize: Scale.fhpx(30),
                        lineHeight: "0px",
                        ...this.cssLabel
                    }
                });

                this.winCurrency = CreateElement("div", {
                    classes: ["but-win-currency", "currency"],
                    parentToAppend: butWin,
                    style: {
                         fontSize: Scale.fhpx(40),
                         textAlign: "center",
                         color: "yellow",
                         textShadow: "0 0 10px black",
                         position: "relative",
                         top: Scale.Ypx(20),
                        //...cssCurrency
                    }
                });

                    // let butWinCurrencyValue = CreateElement("span", {
                    //     classes: ["but-win-currency-value"],
                    //     parentToAppend: butWinCurrency
                    // });

                this.winCredits = CreateElement("div", {
                    classes: ["but-win-credit", "credit"],
                    parentToAppend: butWin,
                    style: {
                        ...cssCredit,
                        fontSize: Scale.fhpx(60),
                        lineHeight: Scale.Hpx(100),
                        marginTop: Scale.Ypx(2),
                    }
                });

                let butWinLinear = CreateElement("div", {
                    classes: ["linear"],
                    parentToAppend: butWin,
                    style: {
                        ...cssLinear,
                    
                    
                    }
                });


        
        // this.view.innerHTML += `
        // <div class="but-vertical-group but-group-autplay-maxbet-spin-messages but-right-group">
        //     <div class="but-message button message-value message" style="border: hidden; box-shadow: none;">
        //     </div>
        
        //     <div class="but-horizontal-group but-group-autoplay-maxbet-spin">
        //         <div class="but-horizontal-group but-group-autoplay-maxbet">
        //             <div class="but-auto-play button" style="visibility: hidden;">
        //                 <div class="but-auto-play-label label"></div>
        //             </div>
        
        //             <div class="but-max-bet button" style="position: relative; left: -100px;">
        //                 <div class="but-max-bet-label label"></div>
        //                 <div class="linear"> </div>
        //             </div>
        //         </div>
        
        
        //         <div class="but-spin button ">
        //             <div id="spindix" class="but-spin-label label"></div>
        //             <div class="linear"> </div>
        //         </div>
        //     </div>
        // </div>`;

        let grpRight = CreateElement("div", {
            classes: ["but-vertical-group", "but-group-autplay-maxbet-spin-messages", "but-right-group"],
            parentToAppend: this.view,
            style: {
                ...cssVerticalGroup,
                width: "100%",
            }
        });

            this.messageElem = CreateElement("div", {
                classes: ["but-message", "button", "message-value", "message"],
                parentToAppend: grpRight,
                style: {
                    height: Scale.Hpx(35),
                    position: "relative",
                    //left: "-30px",
                    //...cssButton,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    fontSize: Scale.fhpx(20),
                    color: "white",
                    textShadow: `0 0 ${Scale.XYpx(10)} black`,
                    background: "transparent",
                    top:"8px",
                    right:Scale.Hpx(70),

                }
            });

            let grpRightHorizontal = CreateElement("div", {
                classes: ["but-horizontal-group", "but-group-autoplay-maxbet-spin"],
                parentToAppend: grpRight,
                style: {
                    ...cssHorizontalGroup,
                    flexGrow: "0",
                    justifyContent: "space-evenly",
                    alignItems:"flex-end",
                    height:"100%",
                }
            });

                let grpAutoplayMaxbet = CreateElement("div", {
                    classes: ["but-horizontal-group", "but-group-autoplay-maxbet"],
                    parentToAppend: grpRightHorizontal,
                    style: {
                        ...cssHorizontalGroup,
                        flexGrow: "0",
                    }
                });

                //     this.butAutoplay = CreateElement("div", {
                //         classes: ["but-auto-play", "button"],
                //         parentToAppend: grpAutoplayMaxbet,
                //         style: {
                //             //flexGrow: "1",
                //             alignSelf: "flex-end",
                //             ...cssButton,
                //             //display: "none",
                //             width: Scale.Wpx(150),
                //         }
                //     });

                //         let butAutplayLabel = CreateElement("div", {
                //             classes: ["but-auto-play-label", "label"],
                //             parentToAppend: this.butAutoplay,
                //             childToAppend: this.translator.Anchor(() => this.translator.t.auto),
                //             style: {
                //                 ...this.cssLabel,
                //                 margin: Scale.XYpx(7),
                //                 lineHeight: Scale.fhpx(20),
                //                 display: "block",
                //             }
                //         });


                //         if (this.buyBonusIsEnabledForAny) {
                //             this.btnChangeBetType = CreateElement("div", {
                //                 classes: ["but-bet", "button"], 
                //                 parentToAppend: grpRightHorizontal,
                //                 style: {
                //                     position: "relative",
                //                     //left: "80px",
                //                     width: Scale.Wpx(110),
                //                     ...cssButton
                //                 }
                //             });
                //             this.betTypeLabel = CreateElement("div", {
                //                 classes: ["but-bet-type"],
                //                 parentToAppend: this.btnChangeBetType,
                //                 style: {
                //                     ...this.cssLabel
                //                 }
                //             });
                //             let betTypeValue = CreateElement("span", { classes: ["but-bet-type"], parentToAppend: this.betTypeLabel, innerHTML: "BUY" });
                //             this.betValue = CreateElement("div", {
                //                 classes: ["but-bet-value"],
                //                 parentToAppend: this.btnChangeBetType,
                //                 innerHTML: "BONUS",
                //                 style: {
                //                     ...this.cssLabel
                //                 }
                //             });
                //         }

                //     this.butMaxBet = CreateElement("div", {
                //         classes: ["but-max-bet", "button"],
                //         parentToAppend: grpAutoplayMaxbet,
                //         style: {
                //             //flexGrow: "1",
                            
                //             alignSelf: "flex-end",
                            
                //             ...cssButton,
                           
                            
                //             width: Scale.Wpx(150),
                //         }
                //     })

                //         let butMaxBetLabel = CreateElement("div", {
                //             classes: ["but-max-bet-label", "label"],
                //             parentToAppend: this.butMaxBet,
                //             childToAppend: this.translator.Anchor(() => this.translator.t.maxbet),
                //             style: {
                //                 ...this.cssLabel,
                //                 marginTop: Scale.Ypx(35),
                //                 lineHeight: Scale.Hpx(20),
                //             }
                //         });

                //         let butMaxBetLinear = CreateElement("div", {
                //             classes: ["linear"],
                //             parentToAppend: this.butMaxBet,
                //             style: {
                //                 ...cssLinear,
                //                 marginTop: Scale.Ypx(20),
                //             }
                //         });

                // if(this.buyBonusIsEnabledForAny)
                // {
                //     this.butSpin = CreateElement("div", {
                //         classes: ["but-spin", "button"],
                //         parentToAppend: grpRightHorizontal,
                //         style: {
                //             width: Scale.Wpx(215),
                //             alignSelf: "flex-end",
                //             ...cssButton,
                //             position: "relative"
                //         }
                //     });
                // }
                // else
                // {
                //     this.butSpin = CreateElement("div", {
                //         classes: ["but-spin", "button"],
                //         parentToAppend: grpRightHorizontal,
                //         style: {
                //             width: Scale.Wpx(300),
                //             alignSelf: "flex-end",
                //             ...cssButton,
                //             position: "relative"
                //         }
                //     });
                // }
        if (this.buyBonusIsEnabledForAny) {
            this.butAutoplay = CreateElement("div", {
                classes: ["but-auto-play", "button"],
                parentToAppend: grpAutoplayMaxbet,
                style: {
                    //flexGrow: "1",
                    alignSelf: "flex-end",
                    ...cssButton,
                    //display: "none",
                    width: Scale.Wpx(110),
                }
            });

            let butAutplayLabel = CreateElement("div", {
                classes: ["but-auto-play-label", "label"],
                parentToAppend: this.butAutoplay,
                childToAppend: this.translator.Anchor(() => this.translator.t.auto),
                style: {
                    ...this.cssLabel,
                    margin: Scale.XYpx(7),
                    lineHeight: Scale.fhpx(20),
                    display: "block",
                }
            });

            this.btnChangeBetType = CreateElement("div", {
                classes: ["but-bet", "button"],
                parentToAppend: grpRightHorizontal,
                style: {
                    position: "relative",
                    //left: "80px",
                    width: Scale.Wpx(110),
                    ...cssButton1
                }
            });
            this.betTypeLabel = CreateElement("div", {
                classes: ["but-bet-type"],
                parentToAppend: this.btnChangeBetType,
                style: {
                    ...this.cssLabel
                }
            });
            let betTypeValue = CreateElement("span", { classes: ["but-bet-type"], parentToAppend: this.betTypeLabel, innerHTML: "BUY" });
            this.betValue = CreateElement("div", {
                classes: ["but-bet-value"],
                parentToAppend: this.btnChangeBetType,
                innerHTML: "BONUS",
                style: {
                    ...this.cssLabel
                }
            });

            this.butMaxBet = CreateElement("div", {
                classes: ["but-max-bet", "button"],
                parentToAppend: grpAutoplayMaxbet,
                style: {
                    //flexGrow: "1",

                    alignSelf: "flex-end",

                    ...cssButton,

                    width: Scale.Wpx(110),
                }
            })

            let butMaxBetLabel = CreateElement("div", {
                classes: ["but-max-bet-label", "label"],
                parentToAppend: this.butMaxBet,
                childToAppend: this.translator.Anchor(() => this.translator.t.maxbet),
                style: {
                    ...this.cssLabel,
                    marginTop: Scale.Ypx(35),
                    lineHeight: Scale.Hpx(20),
                }
            });

            let butMaxBetLinear = CreateElement("div", {
                classes: ["linear"],
                parentToAppend: this.butMaxBet,
                style: {
                    ...cssLinear,
                    marginTop: Scale.Ypx(20),
                }
            });

            this.butSpin = CreateElement("div", {
                classes: ["but-spin", "button"],
                parentToAppend: grpRightHorizontal,
                style: {
                    width: Scale.Wpx(190),
                    alignSelf: "flex-end",
                    ...cssButton,
                    position: "relative"
                }
            });
        }
        else 
        {
            this.butAutoplay = CreateElement("div", {
                classes: ["but-auto-play", "button"],
                parentToAppend: grpAutoplayMaxbet,
                style: {
                    //flexGrow: "1",
                    alignSelf: "flex-end",
                    ...cssButton,
                    //display: "none",
                    width: Scale.Wpx(150),
                }
            });

            let butAutplayLabel = CreateElement("div", {
                classes: ["but-auto-play-label", "label"],
                parentToAppend: this.butAutoplay,
                childToAppend: this.translator.Anchor(() => this.translator.t.auto),
                style: {
                    ...this.cssLabel,
                    margin: Scale.XYpx(7),
                    lineHeight: Scale.fhpx(20),
                    display: "block",
                }
            });

            this.butMaxBet = CreateElement("div", {
                classes: ["but-max-bet", "button"],
                parentToAppend: grpAutoplayMaxbet,
                style: {
                    //flexGrow: "1",

                    alignSelf: "flex-end",

                    ...cssButton,


                    width: Scale.Wpx(150),
                }
            })

            let butMaxBetLabel = CreateElement("div", {
                classes: ["but-max-bet-label", "label"],
                parentToAppend: this.butMaxBet,
                childToAppend: this.translator.Anchor(() => this.translator.t.maxbet),
                style: {
                    ...this.cssLabel,
                    marginTop: Scale.Ypx(35),
                    lineHeight: Scale.Hpx(20),
                }
            });

            let butMaxBetLinear = CreateElement("div", {
                classes: ["linear"],
                parentToAppend: this.butMaxBet,
                style: {
                    ...cssLinear,
                    marginTop: Scale.Ypx(20),
                }
            });

            this.butSpin = CreateElement("div", {
                classes: ["but-spin", "button"],
                parentToAppend: grpRightHorizontal,
                style: {
                    width: Scale.Wpx(245),
                    alignSelf: "flex-end",
                    ...cssButton,
                    position: "relative"
                }
            });
        }
                if (this.params.doubleupEnabled)
                {
                    this.butDoubleUp = CreateElement("div", {
                        classes: ["but-gamble", "button"],
                        parentToAppend: grpAutoplayMaxbet,
                        style: {
                            width: Scale.Wpx(100),
                            alignSelf: "flex-end",
                            ...cssButton,
                            position: "relative"
                        }
                    });
                }

                    // <div class="but-turbo-label">Hold for turbo</div>
                    this.turboElem = CreateElement("div", {
                        classes: ["but-turbo-label"],
                        parentToAppend: this.butSpin,
                        innerHTML: "Hold for turbo",
                        style: {
                            //position: "absolute",
                            top: Scale.Ypx(10),
                            width: "100%",
                            fontSize: Scale.fhpx(12),
                            color: "white",
                            textAlign: "center",
                            textShadow: "#001 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px",
                        }
                    });

                    this.spinElem = CreateElement("div", {
                        classes: ["but-spin-label", "label"],
                        parentToAppend: this.butSpin,
                        style: {
                            ...this.cssLabel,
                            fontSize: Scale.fhpx(40),
                            lineHeight: Scale.Hpx(85)
                           
                        }
                    });

                    if (this.params.doubleupEnabled)
                    {
                        let doubleuplabel = CreateElement("div", {
                            classes: ["but-gamble-label", "label"],
                            parentToAppend: this.butDoubleUp,
                            childToAppend: this.translator.Anchor(() => this.translator.t.doubleup),
                            style: {
                                ...this.cssLabel,
                                marginTop: Scale.Ypx(10),
                                lineHeight: Scale.Hpx(20)
                            
                            }
                        });
                    }


                    let btnSpinLinear = CreateElement("div", {classes: ["linear"], parentToAppend: this.butSpin, style: {
                        ...cssLinear
                    }});
        
        // +
        // `<div class="but-vertical-group but-group-help-games">
        //     <div class="but-help button">
        //         <div class="help-background">
        //             <div class="but-help-icon label">INFO</div>
        //         </div>
        //     </div>
        
        
        //     <div class="but-games button">
        //         <span class="but-games-icon label">MENU</span>
        //     </div>
        // </div>
        // `
        ;

        let rightCol = CreateElement("div", {
            classes: ["but-vertical-group", "but-group-help-games"],
            parentToAppend: this.view,
            style: {
                ...cssVerticalGroup
            }
        });
            this.butHelp = CreateElement("div", {
                classes: ["but-help", "button"],
                parentToAppend: rightCol,
                style: {
                    ...cssButton,
                    ...cssLeftRightButton,
                    
                }
            });

                let butHelpBack = CreateElement("div", {
                    classes: ["help-background"],
                    parentToAppend: this.butHelp
                });

                    let butHelpLabel = CreateElement("div", {
                        classes: ["but-help-icon", "label"],
                        parentToAppend: butHelpBack,
                        innerHTML: "INFO",
                        style: {
                            ...this.cssLabel
                        }
                    });

                    this.butMenu = CreateElement("div", {
                        classes: ["but-games", "button"],
                        parentToAppend: rightCol,
                        style: {                            
                            ...cssButton,
                            ...cssLeftRightButton,
                        }
                    });
                    let butMenuLabel = CreateElement("div", {
                        classes: ["but-games-icon", "label"],
                        parentToAppend: this.butMenu,
                        childToAppend: this.translator.Anchor(() => this.translator.t.menu),
                        style: {
                            ...this.cssLabel,
                            lineHeight : Scale.fhpx(23),
                            
                            
                        }
                    });
    }

	public ResourcesLoaded(resourceManager: IReadOnlyResourceManager) {
		this.view = CreateElement("div", {
            classes: ["panel", this.resid.Scope()],
            style: {
                position: "absolute",
                bottom: "0px",
                boxSizing: "border-box",
                
                width: "100%",
                height: Scale.Hpx(160),
            
                fontFamily: "NotoSansDisplay-Bold",
                fontWeight: "bold",
            
                display: "flex",
                justifyContent: "space-evenly",
                alignContent: "space-around",

                transformOrigin: "bottom",
		        zIndex: ZIndex.Panel.toString(),
                gap: Scale.Xpx(30)
            }
        });
        
        //this.view.innerHTML = resourceManager.Get<HTMLResource>(this.resid.ScopedResourceName("html")).html;
        this.ConstructHtml();

		this.ConstructButton(Button.ButtonSpin, this.butSpin);
        this.ConstructButton(Button.ButtonCreditsMoney, this.btnBalance);
        if (this.buyBonusIsEnabledForAny) 
        {
            this.ConstructButton(Button.ButtonChangeBetType, this.btnChangeBetType);
        }

		//quit this accion button 
		//this.ConstructButton(Button.ButtonLines, this.view.querySelector(".but-lines"));
		this.ConstructButton(Button.ButtonBetNext, this.butTotalBet);
		//quit this accion button 
	    this.ConstructButton(Button.ButtonPayout, this.butcash);
		//quit this accion button 
		//this.ConstructButton(Button.ButtonDenom, this.view.querySelector(".but-select-denom"));
		this.ConstructButton(Button.ButtonHelp, this.butHelp, 500);
        if (Settings.MenuType != MenuType.DummyMenu)
            this.ConstructButton(Button.ButtonGamesMenu, this.butMenu, 500);
		this.ConstructButton(Button.ButtonVolumeNext, this.butVolume);
		//quit this accion button 
		//this.ConstructButton(Button.ButtonCredit, this.view.querySelector(".but-credit"));
		this.ConstructButton(Button.ButtonAutoplay, this.butAutoplay);
		this.ConstructButton(Button.ButtonMaxBet, this.butMaxBet);
		this.ConstructButton(Button.ButtonDenomMenu, this.butDenom, 500);
        this.ConstructButton(Button.ButtonCallAttendant,this.attendantElem);

        if (this.params.doubleupEnabled)
        {
            this.ConstructButton(Button.ButtonDoubleUp, this.butDoubleUp);
        }

		// this.panelElements.push(this.butTotalBet);
		// this.panelElements.push(this.butHelp);
		// this.panelElements.push(this.butMenu);
		// this.panelElements.push(this.butVolume);
		// this.panelElements.push(this.butDenom);
		// this.panelElements.push(this.view.querySelector(".but-totalbet"));
		// this.panelElements.push(this.view.querySelector(".but-win"));
		// this.panelElements.push(this.view.querySelector(".but-credit"));
		// this.panelElements.push(this.butMaxBet);
		// this.panelElements.push(this.butSpin);
		
		//let btnColor = this.ButtonBackground();
		
		// let linearElement= this.view.querySelectorAll(".linear");
		// SetStyles(linearElement,{
		// 	borderImage: btnColor.linearColor,
		// })
		
		// SetStyles(this.panelElements,{
		// 	backgroundImage:btnColor.backgroundButtonColor,
		// })

		// this.balanceCredits = this.view.querySelector(".but-credit-credit")
        // this.balanceCurrency = this.view.querySelector(".but-credit-currency")

		//this.winCredits = this.view.querySelector(".but-win-credit")
		//this.winCurrency = this.view.querySelector(".but-win-currency")

		// this.betCredits = this.view.querySelector(".but-betperline-credit")
		// this.betCurrency = this.view.querySelector(".but-betperline-currency")

		// this.totalBetCredits = this.view.querySelector(".but-totalbet-credit")
		// this.totalBetCurrency = this.view.querySelector(".but-totalbet-currency")

		// this.balanceCredits = this.view.querySelector(".but-credit-credit")
		// this.balanceCurrency = this.view.querySelector(".but-credit-currency")

		//this.denomElem = this.view.querySelector(".denom-denom")
		//this.linesElem = this.view.querySelector(".selected-lines")
		//this.spinElem = this.view.querySelector(".but-spin-label")

		//this.turboElem = this.view.querySelector(".but-turbo-label")

        if (this.backendSettings != null) {
            if (!this.backendSettings.GetBool("play.turbo") && this.backendSettings != null) {
                this.turboElem.style.display = "none";
            }
        }

		this.volume0 = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["volume0", "image"]));
		this.volume1 = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["volume1", "image"]));
		this.volume2 = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["volume2", "image"]));
		this.volume3 = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["volume3", "image"]));
		
		
		//this.view.querySelector(".but-spin-label").innerHTML = "SPIN";
		this.audio.OnVolumeChange((volumeLevel :number, volumeFactor: number)=> this.OnVolumeChange(volumeLevel,volumeFactor));

		//this.turboAnim.Start();
        this.CallAttendantLoaded();
        //Call funtion for create anim 
        this.AutoPlayLoaded();
	}

	//Gradient

	protected ButtonBackground(): ButtonColors
	{
        // let color: ButtonColors =
        // {
		// 	backgroundButtonColor: "linear-gradient(rgb(0, 0, 0), rgb(22, 22, 206),rgb(0, 0, 0)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
		// 	linearColor:"linear-gradient(to left , transparent, LightGoldenrodYellow,transparent ) 0 10 100%",
        // };
        
		return this.panelColors;
	}
	

	protected started: boolean = false;

	public Start(): void
	{
		this.started = true;
		this.OnIdleBegin();

		this.IdleAnimStart();
	}

	public Stop(): void
	{
		this.IdleAnimStop();
		//this.butElem.get(Button.ButtonSpin).style.boxShadow= "0 0px 16px  rgb(255, 0, 0)";
		this.started = false;
	}

	protected ConstructButton(button: Button, element: HTMLElement, autoRelease: number = 0): void
	{
        if (!element)
        {
            debugger;
            throw new Error ("Element can't be empty");
        }

        if (this.buttonState.get(button))
        {
            debugger;
            throw new Error (`Button ${button} already constructed`);
        }

        {
            let buttonState: ButtonState = {
                button: button,
                element: element,
                isPressed: false,
                delayReleaseTime: this.systemContext.TimingContext().CreateTimeout(`Button-${button}-delayrelease`, 100, () => {
                    
                    if (buttonState.releasePending)
                    {
                        this.AnimateButtonPress(buttonState, false);
                    }

                    buttonState.releasePending = false;
                }),

                releasePending: false,
                autoReleaseTimer: autoRelease > 0 ? this.systemContext.TimingContext().CreateTimeout(`Button-${button}-autorelease`, autoRelease, () => {
                    this.AnimateButtonPress(buttonState, false);
                    buttonState.releasePending = false;
                }) : null
            };

            this.buttonState.set(button, buttonState);
        }

		this.butElem.set(button, element);

        AddMouseDownUpListener(
            element, 
            () => service.iomanager.UpdateButton(button, true),
            () => service.iomanager.UpdateButton(button, false)
        );
	}

    public ButtonChanged(button: Button, pressed: boolean): void
    {
        if (pressed)
        {
            this.ButtonPressed(button);
        }
        else
        {
            this.ButtonReleased(button);
        }
    }

	protected ButtonPressed(button: Button): void
	{
		// Log.Debug("Panel", "Button " + button + " pressed");

        let buttonState = this.buttonState.get(button);
        if (buttonState)
        {

            // not pressed, press now
            if (!buttonState.isPressed)
            {
                buttonState.isPressed = true;
                buttonState.releasePending = false;
                buttonState.delayReleaseTime?.Start();
                buttonState.autoReleaseTimer?.Start();

                this.AnimateButtonPress(buttonState, true);
            }
        }
        else
        {
            // no such button on panel
        }
	}

	protected ButtonReleased(button: Button): void
	{
        // Log.Debug("Panel", "Button " + button + " released");
        
        
        let buttonState = this.buttonState.get(button);
        if (buttonState)
        {
            if (buttonState.isPressed)
            {
                // pressed, release now
                buttonState.isPressed = false;
                buttonState.autoReleaseTimer?.Stop();

                if (buttonState.delayReleaseTime?.Running())
                {
                    buttonState.releasePending = true;
                }
                else
                {
                    this.AnimateButtonPress(buttonState, false);
                    buttonState.releasePending = false;
                }
            }
        }
        else
        {
            // no such button on panel
        }
	}

	// public HardwareButtonPressed(button: PanelButton, pressed: boolean): void
	// {
    //     // TODO integrate hardware buttons into panel????
    //     let buttonState = this.buttonState.get(button);
	// 	if (pressed)
	// 	{
	// 		// Log.Debug("Panel", "Hardware button " + PanelButton[button] + " pressed");
	// 	}
	// 	else
	// 	{
	// 		// Log.Debug("Panel", "Hardware button " + PanelButton[button] + " released");
    //     }

    //     //this.AnimateButtonPress(buttonState, pressed);
	// }


    protected AnimateButtonPress(buttonState: ButtonState, pressed: boolean): void 
    {
        // press
        if (pressed)
        {
            if (buttonState.button === Button.ButtonChangeBetType)
            {
                SetStyles(buttonState.element, {
                    transform: `translateY(${Scale.Ypx(-8)})`,
                    boxShadow: `${Scale.Xpx(0)} ${Scale.Ypx(5)} ${Scale.XYpx(16)} rgb(255,215,0)`,
                });
                return;
            }
            SetStyles(buttonState.element, {
                transform: `translateY(${Scale.Ypx(-8)})`,
                boxShadow: `${Scale.Xpx(0)} ${Scale.Ypx(5)} ${Scale.XYpx(16)} rgb(0,255 , 0)`,
            });
        }
        // release
        else
        {
            SetStyles(buttonState.element, {
                transform: "translateY(0px)",
                boxShadow: "none",
            })
        }
	}


	// private buttonPressedCallbacks: Map<Button, PanelButtonPressedCallback> = new Map<Button, PanelButtonPressedCallback>();
	// public SetOnButtonPressedCallback(button: Button, callback: PanelButtonPressedCallback)
	// {
	// 	this.buttonPressedCallbacks.set(button, callback);
	// }

	public View(): HTMLElement
	{
		return this.view;
	}


	public SetBet(betCredit: string, betCurrency: string, bet: Money): void
	{
        this.totalBet = bet;
		this.betCredits.textContent = betCredit;
		this.betCurrency.textContent = betCurrency;
		//this.view.querySelector(".but-betperline-value").textContent = betCurrency;
	}

    protected totalBetCreditsValue: string;
    protected totalBetCurrencyValue: string;

    public ChangeTotalBet(totalCredit: string, totalCurrency: string, totalBet: Money): void {
        this.totalBet = totalBet;
        //this.totalBetCredits.textContent = totalCredit;
        //this.totalBetCurrency.textContent = totalCurrency;
        this.totalBetCreditsValue = totalCredit;
        this.totalBetCurrencyValue = totalCurrency;

        if (this.switched) {
            this.totalBetCredits.textContent = totalCurrency;
            this.totalBetCurrency.textContent = totalCredit;
        }
        else {
            this.totalBetCredits.textContent = totalCredit;
            this.totalBetCurrency.textContent = totalCurrency;
        }

        this.UpdateFreeRoundsStats();
    }

    // public ChangeBetTypeValueString(betTypeString: string): void {
    //         this.betValue.textContent = betTypeString;
    // }
    public UpdateBuyBonusStyle(enabled: boolean): void {
        if (!enabled)
        {
            this.btnChangeBetType.style.backgroundImage = "linear-gradient(rgb(135, 135, 135), rgb(161, 161, 161), rgb(97, 95, 95)), linear-gradient(rgb(191, 149, 63), rgb(252, 246, 186), rgb(179, 135, 40), rgb(251, 245, 183), rgb(170, 119, 28))";
            return;
        }

        this.btnChangeBetType.style.backgroundImage= "linear-gradient(rgb(139, 0, 0), rgb(178, 34, 34), rgb(139, 0, 0)), linear-gradient(#BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)"

        // this.cssButton1.backgroundColor= "linear-gradient(rgb(139, 0, 0), rgb(178, 34, 34), rgb(139, 0, 0)), linear-gradient(#BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)";

    }


    protected winCreditsValue: string;
    protected winCurrencyValue: string;

    public SetWin(totalWinCredit: string, totalWinCurrency: string): void {
        //this.winCredits.textContent = totalWinCredit;
        //this.winCurrency.textContent = totalWinCurrency;
        this.winCreditsValue = totalWinCredit;
        this.winCurrencyValue = totalWinCurrency;

        if (this.switched) {
            this.winCredits.textContent = totalWinCurrency;
            this.winCurrency.textContent = totalWinCredit;
        }
        else {
            this.winCredits.textContent = totalWinCredit;
            this.winCurrency.textContent = totalWinCurrency;
        }
    }
	

    protected balanceCreditValue: string;
    protected balanceCurrencyValue: string;

    public SetBalance(totalBalanceCredit: string, totalBalanceCurrency: string,): void {
        this.balanceCreditValue = totalBalanceCredit;
        this.balanceCurrencyValue = totalBalanceCurrency;

        if (this.switched) {
            this.balanceCredits.textContent = totalBalanceCurrency;
            this.balanceCurrency.textContent = totalBalanceCredit;
        }
        else {
            this.balanceCredits.textContent = totalBalanceCredit;
            this.balanceCurrency.textContent = totalBalanceCurrency;

        }

    }

	public SetDenom(denom:string): void {        
        this.denom = denom;
		this.denomElem.textContent = this.denom;
        this.linesDenomMessage.Update();
	}

	public SetLines(lines: number): void {        
        //this.linesElem.textContent = " " + lines;
        this.lines = lines;
        this.linesDenomMessage.Update();
	}

	public SpinButtonLabelChange(state: string): void
	{
		this.spinElem.textContent = state;
	}

	protected spinBackgound:string = "";
	public OnIdleBegin():void
	{
		if (!this.started) return;
		//this.spinBackgound = this.butElem.get(PanelButton.Spin).style.background;
		
		this.IdleAnimStart();
	}

	public OnIdleEnd():void
	{
		this.IdleAnimStop();
		//this.butElem.get(Button.ButtonSpin).style.boxShadow= "0 0px 16px  rgb(255, 0, 0)";
	}

	public SetMessage(message: string): void {
        //this.view.querySelector(".message").innerHTML = message;
        this.messageElem.textContent = message;
	}

	// public AutoplayEnabled(): void {
    //     SetStyles(this.buttonState.get(Button.ButtonAutoplay).element, {
    //         transform: "translateY(-8px)",
    //         boxShadow: "0 0px 16px rgb(251, 255, 0)",
    //     });
	// }

    public TurboEnabled() {
        if (this.backendSettings != null) {
            if (this.backendSettings.GetBool("play.turbo")) {
                this.turboElem.style.visibility = "hidden";

                this.butElem.get(Button.ButtonSpin).style.boxShadow = "0 0px 16px  rgb(255, 0, 0)";
                this.butElem.get(Button.ButtonSpin).style.backgroundColor = "rgb(255, 0, 0)";

                this.audio.Play(this.resid.ScopedResourceName("turbostart"));
            }
        }
    }

    public TurboDisabled() {
        if (this.backendSettings != null) {
            if (this.backendSettings.GetBool("play.turbo")) {
                this.turboElem.style.visibility = "visible";
                this.IdleAnimStop();
                this.audio.Play(this.resid.ScopedResourceName("turbostop"));
            }
        }
    }

	public OnVolumeChange(volumeLevel:number, volumeFactor: number):void{

		// let vol:HTMLElement = this.view.querySelector(".but-vol-value");
        // if (!this.butVolLabel){
        //     return;
        // }

		SetStyles(this.butVolLabel,
		{
			width: Scale.Wpx(70),
			height: Scale.Hpx(59),
			backgroundPosition:"center",
			backgroundRepeat: "no-repeat",
			backgroundSize: "contain",
			
		});

		switch(volumeLevel)
		{
			case 0:
				SetStyles(this.butVolLabel,
				{
					background: this.volume0.CssBackground(),
					backgroundSize: "contain",
   					backgroundRepeat: "no-repeat",
    				backgroundPosition: "center",
				});
				//vol.innerHTML = '<span class="fas fa-volume-mute fa-3x"></span>';
			break;
			case 1:
				SetStyles(this.butVolLabel,
				{
					background: this.volume1.CssBackground(),
					backgroundSize: "contain",
   					backgroundRepeat: "no-repeat",
    				backgroundPosition: "center",
				});
				//vol.innerHTML = '<span class="fas fa-volume-down fa-3x"></span>';
			break;
			case 2:
				SetStyles(this.butVolLabel,
				{
					background: this.volume2.CssBackground(),
					backgroundSize: "contain",
   					backgroundRepeat: "no-repeat",
    				backgroundPosition: "center",
				});
				//vol.innerHTML = '<span class="fas fa-volume-up fa-3x"></span>';
			break;
			case 3:
				SetStyles(this.butVolLabel,
				{
					background: this.volume3.CssBackground(),
					backgroundSize: "contain",
   					backgroundRepeat: "no-repeat",
    				backgroundPosition: "center",
				});
				//vol.innerHTML = '<span class="fas fa-volume-up fa-3x"></span>';
			break;
		}

	}
    
	public DisableButSpin(): void
	{
		//this.view.querySelector("but-play").disabled = true;
	}

	// public AutoplayDisable(): void{
	// 	if(this.autoplayAnimation !=null )
	// 	{
	// 		this.autoplayAnimation.kill();
	// 	}

	// 	this.butElem.get(Button.ButtonAutoplay).style.transform= "translateY(0px)";
	// 	this.butElem.get(Button.ButtonAutoplay).style.boxShadow= "none";
	// }

	public Hide(): void {
		this.view.style.visibility = "hidden";
	}

	public Show(): void {
		this.view.style.visibility = "visible";
	}

	public OnSpinBegin(): void {
		
		//TweenLite.fromTo(this.view, 0.25, {perspective: 800}, {rotationX: 45});
		
	}

	public OnSpinEnd(): void {
		
		//TweenLite.to(this.view, 0.25, {rotationX: 0});
		
	}

    public UpdateInfo(Bets? : BetConfig[]):void{
	}

    public ChangeState(state : GameState){

    }
    

    protected callAttendantTimer: IInterval = null;;
    protected callAttendantColor: string = null;
    protected CallAttendantPrepare(): void
    {
    }

    protected CallAttendantLoaded()
    {
        let callAttendantButtonElem = this.butElem.get(Button.ButtonCallAttendant);
        if (callAttendantButtonElem)
        {
            this.callAttendantTimer = this.systemContext.TimingContext().CreateInterval("callattendant", 500, () => {
                if (this.callAttendantColor == "red")
                {
                    this.callAttendantColor = "transparent";
                }
                else
                {
                    this.callAttendantColor = "red";
                }

                callAttendantButtonElem.style.borderColor = this.callAttendantColor;
            });
        }
    }

    public CallAttendant(): void
    {
        this.callAttendantTimer?.Start();
    }

    public CancelCallAttendant(): void
    {
        this.callAttendantTimer?.Stop();
        let callAttendantButtonElem = this.butElem.get(Button.ButtonCallAttendant);
        if (callAttendantButtonElem)
        {
            callAttendantButtonElem.style.borderColor = "transparent"
        }

        this.callAttendantColor = null;
    }

    //Autoplay

    protected autoPlayTimer: IInterval = null;;
    protected autoPlayColor: string = null;
    protected AutoPlayPrepare(): void
    {
    }

    protected AutoPlayLoaded()
    {
        let autoPlayButtonElem = this.butElem.get(Button.ButtonAutoplay);
        if (autoPlayButtonElem)
        {
            this.autoPlayTimer = this.systemContext.TimingContext().CreateInterval("autoplay", 500, () => {
                if (this.autoPlayColor == "red")
                {
                    this.autoPlayColor = "transparent";
                }
                else
                {
                    this.autoPlayColor = "red";
                }

                autoPlayButtonElem.style.borderColor = this.autoPlayColor;
            });
        }
    }

    public AutoplayEnable(): void
    {
        this.autoPlayTimer?.Start();
    }

    public AutoplayDisable(): void
    {
        this.autoPlayTimer?.Stop();
        let autoPlayButtonElem = this.butElem.get(Button.ButtonAutoplay);
        if (autoPlayButtonElem)
        {
            autoPlayButtonElem.style.borderColor = "transparent"
        }

        this.autoPlayColor = null;
    }

    public Update(){}

    // public OnSpeedChange()
    // {

    // }
    public async ShowPopUp(){
        
    }

    // public OnSpeedChanged: SpeedChangedCallback;
    public HidePopUp()
    {

    }

    public CheckPopUpVisibility():boolean
    {
        return false;
    }

    protected enabledBets: BetConfig[] = [];

    public SetEnabledBets(list: BetConfig[]):void 
    {
        this.enabledBets = list;

        this.IfBuyBonusCreditsIsZero();
        this.BuyBonusEnabledForAny();
    }

    public IfBuyBonusCreditsIsZero(): void
    {
        for(var bet of this.enabledBets) {
            if (bet.Bet.BuyBonusCredits === 0) {
                bet.BuyBonusEnabled = false;
            }
        }
    }

    protected buyBonusIsEnabledForAny: boolean = false;

    public BuyBonusEnabledForAny(): void
    {
        if (this.enabledBets.some(bet => bet.BuyBonusEnabled))
        {   
            this.buyBonusIsEnabledForAny = true;
            return;
        }
        this.buyBonusIsEnabledForAny = false;
    }

    public OnResize(w: number, h: number, orientation: Orientation)
    {
        
    }

    /** Habilita o deshabilita el botón DoubleUp (solo cuando hay ganancia). */
    public SetDoubleUpEnabled(enabled: boolean): void {
        if (this.butDoubleUp) {
            this.butDoubleUp.style.pointerEvents = enabled ? "auto" : "none";
            this.butDoubleUp.style.opacity = enabled ? "1" : "0.5";
        }
    }

}

// export type SpeedChangedCallback = (speed: ChangeSpeedParams) => void;
